import { GlobalData } from "../../Common/GlobalData";
import { HtmlHelpers } from "../../Common/HtmlHelpers";
import { TemplateHelpers } from "../../Common/KendoHelpers";

export class EarlyBuyPatterns {
    private static readonly REPORT_DATE = '#closingDate';
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(EarlyBuyPatterns.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_EARLY_BUY_PATTERNS,
                }
            },
            dataBound: () => {
                const data = $(EarlyBuyPatterns.GRID).data('kendoGrid')!.dataSource.data();
                if (data && data.length > 0) {
                    $(EarlyBuyPatterns.REPORT_DATE).html(
                        HtmlHelpers.getFormattedDate(data[0].closingDate));
                }
            },

            height: 915,
            groupable: false,
            pageable: false,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '20%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: "close",
                    title: "Closing<br />Price",
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: 'pattern',
                    title: 'Pattern',
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'stageA',
                    title: 'Stage<br />A',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "pctFromFiftyDaySma",
                    title: "% From<br />50 Day",
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:p1}',
                },
                {
                    field: "pivotPoint",
                    title: "Pivot<br />Point",
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },                   
                {
                    field: "pivotDate",
                    title: "Pivot<br />Date",
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('pivotDate')),
                },
                {
                    field: "breakoutDate",
                    title: "Breakout<br />Date",
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('breakoutDate')),
                },
                {
                    field: 'pivotNote1',
                    title: 'PivotNote1',
                    width: '15%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'compositeRating',
                    title: 'Comp<br />Rating',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:n0}',
                },
            ]
        });
    }
}
